import { Result } from '@uppy/transloadit';

export interface UppyUploaderProps {
  handleUpload: (files: Result[]) => void;
  uniqIdentifier: string;
  trigger: `#${string}`;
  button?: boolean;
  closeOnComplete?: boolean;
  locale?: {
    strings: {
      dropHereOr: string;
      browse: string;
    }
  };
  restrictions?: {
    maxNumberOfFiles?: number;
    maxFileSize?: number;
    allowedFileTypes?: string[];
  };
  template?: string;
};
